import React from 'react'
import PageLayout from '../pagelayout';
import Map from "../Map/map";
import HowContent from "./howcontent"

const HomeLayout = ({children}) => (
    <PageLayout Map={Map}>
        <HowContent>
            {children}
        </HowContent>
    </PageLayout>
)

export default HomeLayout
